import type { TFunction } from "i18next";
import { isApiError } from "../../api/client.js";

export function inboxWorkflowErrorMessage(t: TFunction, error: unknown, fallback: string): string {
  if (!isApiError(error)) return t("inbox.workflow.errors.generic");
  if (error.status === 0) return fallback;
  switch (error.code) {
    case "CONVERSATION_ASSIGNEE_NOT_ASSIGNABLE":
      return t("inbox.workflow.errors.assignee");
    case "CONVERSATION_MARK_UNREAD_NO_INBOUND":
      return t("inbox.workflow.errors.noCustomerMessage");
    case "CONVERSATION_EXPORT_TOO_LARGE":
      return t("inbox.workflow.errors.exportTooLarge");
    case "CONVERSATION_NOT_FOUND":
      return t("inbox.workflow.errors.notFound");
    case "ORGANIZATION_SUSPENDED":
      return t("organization.suspended.body");
    default:
      return t("inbox.workflow.errors.generic");
  }
}
